import ComponentManager from '@/Management/ComponentManager';
import InlineEditingGrid from '@/Controls/InlineEditingGrid';
import ExtendedInlineEditingGridViewModel from '@/Components/ExtendedInlineEditingGrid/ExtendedInlineEditingGridViewModel';
import ToolBarType from '@/Controls/ToolBar';
import FilterType from '@/Controls/Filter';
import {
    DisposeBehavior,
    ICoreFrameGridBindingParameter,
    IExtendedInlineEditingGenericDTO
} from '#/DefaultViewExtensionInterfaces';
import { IHeaderCol } from 'rad-coreframe-grid';
import ResourceManager from '@/Management/ResourceManager';
import Utilities from '@/Utility/Utilities';
import ExtIEGEditLinkViewModel from '@/Components/ExtendedInlineEditingGrid/Links/ExtIEGEditLinkViewModel';

export default class ExtendedInlineEditingGrid extends InlineEditingGrid {

    private ToolBar = ComponentManager.getControl<typeof ToolBarType>('ToolBar');
    private Filter = ComponentManager.getControl<typeof FilterType>('Filter');
    private extendedjQueryControl: JQuery;

    /**
     * @override
     */
    protected viewModel: ExtendedInlineEditingGridViewModel;

    public constructor(viewModel: ExtendedInlineEditingGridViewModel, element?: JQuery) {
        super(viewModel, element);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.extendedjQueryControl != null) {
            return this.extendedjQueryControl;
        }

        let baseControl = super.getControl();

        this.extendedjQueryControl = $('<div>');
        $('<div class="toolbar">').appendTo(this.extendedjQueryControl);
        $('<div class="filter"><div></div></div>').appendTo(this.extendedjQueryControl);
        baseControl.appendTo(this.extendedjQueryControl);

        if (this.viewModel.toolBar != null) {
            const toolBar = new this.ToolBar(this.viewModel.toolBar, this.extendedjQueryControl.find('.toolbar'));
            toolBar.getTuple();
        }

        if (this.viewModel.filter != null) {
            const filter = new this.Filter(this.viewModel.filter, this.extendedjQueryControl.find('.filter'));
            filter.getTupleAsync();
        }

        this.applyBindings(this.extendedjQueryControl, {
            controlName: 'extendedinlineeditinggrid'
        });
        
        return this.extendedjQueryControl;
    }

    protected getColumnsForResizing(): IHeaderCol[] {
        return this.viewModel.columns();
    }

    /**
     * @override
     */
    protected getGridBindingParameter(): Partial<ICoreFrameGridBindingParameter> {
        let params = super.getGridBindingParameter();
        params.onSelectionChange = this.viewModel.onSelectionChanged.bind(this.viewModel);
        params.selectionMode = this.viewModel.isMultiSelection ? 'multiple' : 'single';
        params.canAdd = false;
        params.editable = this.definePureComputed({
            read: () => {
                return {
                    isInstantEdit: true,
                    showEditColumn: false,
                    saveOnFocusLost: false
                }
            }
        });
        params.paging = this.definePureComputed({
            read: () => {
                return {
                    isEnabled: true,
                    custom: true,
                    currentPage: this.viewModel.page(),
                    pageSize: this.viewModel.pageSize(),
                    pageSizes: this.viewModel.pageSizes(),
                    totalRows: this.viewModel.totalRows(),
                    onPageSizeChanged: this.viewModel.onPageSizeChanged.bind(this.viewModel),
                    onPageChanged: this.viewModel.onPageChanged.bind(this.viewModel)
                };
            }
        });
        params.summaryRow = this.defineComputed(() => {
            return {
                isEnabled: true,
                preText: `${ResourceManager.getInstance().get('DATAGRID_COUNT')} `,
                text: this.viewModel.totalRows().toString()
            }
        })
        params.doubleClickToEdit = false;
        params.onDblClick = (id: any, rowData: IExtendedInlineEditingGenericDTO, evt: JQuery.Event) => {
            this.viewModel.selected([rowData]);
            const editLink = this.viewModel.toolBar.getElementByErgName('EDIT_CONNECTED') as ExtIEGEditLinkViewModel;
            if (Utilities.isNullOrUndefined(editLink) || !editLink.isEnabled())
                return;

            editLink.onClick(evt.ctrlKey, evt);
        }
        params.locator = this.defineComputed(() => {
            return ko.unwrap(params.locator) + '.datagrid';
        });
        params.onAfterRender = this.setColumnSizesForEditMode.bind(this);

        return params;
    }

    protected needCustomMinColWidth(): boolean {
        return false;
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}

ComponentManager.setControl('ExtendedInlineEditingGrid', ExtendedInlineEditingGrid, 'RADPresentation.HTMLClient.DefaultViewExtensions');